module.exports = __webpack_public_path__ + "img/huaweilogo.ed54719b.png";